import { Companion_getInstance1a3oieudzv4l4 as Companion_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/PrimitiveRanges.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_indices3txodfl5wuu5j as get_indices } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var EmptyClass;
function Empty() {
  if (EmptyClass === VOID) {
    class $ {
      yh() {
        return Companion_getInstance().g2_1;
      }
      adk(index) {
        return Unit_instance;
      }
      q1(index) {
        this.adk(index);
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'Empty', VOID, VOID, [RecyclerViewData()]);
    EmptyClass = $;
  }
  return EmptyClass;
}
var Empty_instance;
function Empty_getInstance() {
  return Empty_instance;
}
var FromListClass;
function FromList() {
  if (FromListClass === VOID) {
    class $ {
      constructor(list) {
        this.bdk_1 = list;
        this.cdk_1 = get_indices(this.bdk_1);
      }
      yh() {
        return this.cdk_1;
      }
      q1(index) {
        if (!(0 <= index ? index <= (this.bdk_1.p1() - 1 | 0) : false))
          throw IndexOutOfBoundsException().je('Index ' + index + ' out of range for ' + get_indices(this.bdk_1).toString());
        return this.bdk_1.q1(index);
      }
    }
    initMetadataForClass($, 'FromList', VOID, VOID, [RecyclerViewData()]);
    FromListClass = $;
  }
  return FromListClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      wde(list) {
        return new (FromList())(list);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
var RecyclerViewDataClass;
function RecyclerViewData() {
  if (RecyclerViewDataClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'RecyclerViewData');
    RecyclerViewDataClass = $;
  }
  return RecyclerViewDataClass;
}
//region block: init
Empty_instance = new (Empty())();
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  RecyclerViewData as RecyclerViewDatag1ccuuuhm5zb,
  Companion_instance as Companion_instanceyb6grjkdzphm,
  Empty_instance as Empty_instance39ymueej3v1xr,
};
//endregion

//# sourceMappingURL=RecyclerViewData.mjs.map
